import { render, staticRenderFns } from "./Feedbacks.vue?vue&type=template&id=65254849&scoped=true"
import script from "./Feedbacks.vue?vue&type=script&lang=js"
export * from "./Feedbacks.vue?vue&type=script&lang=js"
import style0 from "./Feedbacks.vue?vue&type=style&index=0&id=65254849&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65254849",
  null
  
)

export default component.exports